// Synthesized water-drop notification sound using Web Audio API.
// No external files needed. Produces a gentle "ding" with a quick pitch drop
// and a soft reverb-like tail.

let _ctx = null;
const getCtx = () => {
  if (typeof window === "undefined") return null;
  if (_ctx) return _ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  _ctx = new AC();
  return _ctx;
};

export const playWaterDrop = () => {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    // Resume context if suspended (browser autoplay policy after first user gesture)
    if (ctx.state === "suspended") ctx.resume();

    const now = ctx.currentTime;

    // Main oscillator (high → low pitch sweep for "drop" feel)
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, now);                 // start high
    osc.frequency.exponentialRampToValueAtTime(220, now + 0.18); // quick downward sweep

    // Gain envelope (soft attack, gentle decay)
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.22, now + 0.015); // soft attack
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.45); // long-ish decay

    // Tiny delay node for subtle reverb tail
    const delay = ctx.createDelay();
    delay.delayTime.value = 0.12;
    const delayGain = ctx.createGain();
    delayGain.gain.value = 0.14;
    const feedback = ctx.createGain();
    feedback.gain.value = 0.18;

    osc.connect(gain);
    gain.connect(ctx.destination);
    gain.connect(delay);
    delay.connect(delayGain);
    delayGain.connect(ctx.destination);
    delay.connect(feedback);
    feedback.connect(delay);

    osc.start(now);
    osc.stop(now + 0.55);
  } catch {
    /* Silent fail — sound is an enhancement, never block */
  }
};
